"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventbriteBulkImportRequestDto = exports.EventbriteBulkImportItemDto = exports.EventbriteImportRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class EventbriteImportRequestDto {}
exports.EventbriteImportRequestDto = EventbriteImportRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite event link (e.g. https://www.eventbrite.com/e/some-party-tickets-123456789012) or the numeric event ID.'
}), __metadata("design:type", String)], EventbriteImportRequestDto.prototype, "url", void 0);
class EventbriteBulkImportItemDto {}
exports.EventbriteBulkImportItemDto = EventbriteBulkImportItemDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite event ID.'
}), __metadata("design:type", String)], EventbriteBulkImportItemDto.prototype, "eventbriteId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Ivy venue to create the event at.'
}), __metadata("design:type", String)], EventbriteBulkImportItemDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "Event name on Ivy; Eventbrite's name when empty."
}), __metadata("design:type", String)], EventbriteBulkImportItemDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "Visibility of this event; the request's visibility when empty."
}), __metadata("design:type", String)], EventbriteBulkImportItemDto.prototype, "visibility", void 0);
class EventbriteBulkImportRequestDto {}
exports.EventbriteBulkImportRequestDto = EventbriteBulkImportRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: [EventbriteBulkImportItemDto]
}), __metadata("design:type", Array)], EventbriteBulkImportRequestDto.prototype, "items", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "Visibility of the created events (default 'public')."
}), __metadata("design:type", String)], EventbriteBulkImportRequestDto.prototype, "visibility", void 0);
//# sourceMappingURL=EventbriteImport.dto.js.map